import React, {ChangeEvent, Component, ReactNode} from 'react'
import { Box, Grid } from '@mui/material';
import {
    FullWidthLeftColumnFlexContainer,
    FullWidthLeftRowFlexContainer,
    RowFlexContainer,
} from '../../../../../styledComponents/FlexComponents'
import EventEmitterExAdmin from '../../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {DialogItemNameArea} from '../../common/admin/NatAdminApplicationCommon'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES} from '../../../../../CodeMaster'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {RequiredChip} from '../../../../../styledComponents/adminPage/Table'
import {addEmptyData} from '../../../../../componentHelper/selectHelper'
import PPDatePicker from '../../../../../components/shared/forms/PPDatePicker'
import PPSelect, {OptionProps} from '../../../../../components/shared/forms/PPSelect'
import PPTextField from '../../../../../components/shared/forms/PPTextField'
import {Nullable} from '../../../../../app/TypeHelpers'
import {formatForDateInput} from '../../../../../formatters/formatDate'
import {fromTimeToMoment} from '../../../../../dateHelpers/MomentHelper'
import FormErrorMessage from '../../../../../components/shared/forms/FormErrorMessage'
import PPErrorDisplaySpan from '../../../../../components/shared/forms/PPErrorDisplaySpan'
import {BrowseWitnessInfo} from '../NatAdminBrowsePage'
import {isMobile} from 'react-device-detect'
import PPOutlinedTextField from '../../../../../components/shared/forms/PPOutlinedTextField'
import OutlinedDatePicker from './OutlinedDatePicker'
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    isInitial: boolean
    onChange: (value: BrowseWitnessInfo) => void
    eventEmitter: EventEmitterExAdmin
}

interface State {
    browseDate: string
    browseStartTimeHours: string
    browseStartTimeMinutes: string
    browseEndTimeHours: string
    browseEndTimeMinutes: string
    witness1RidgeNameRoomNumber: string
    witness1Name: string
    witness2RidgeNameRoomNumber: string
    witness2Name: string
    otherWitness: string
    clearErrorBrowseStartTime: boolean
    clearErrorBrowseEndTime: boolean
    isErrorOfPeriod: boolean
}

export default class NatAdminBrowseWitnessForm extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            browseDate: '',
            browseStartTimeHours: '',
            browseStartTimeMinutes: '',
            browseEndTimeHours: '',
            browseEndTimeMinutes: '',
            witness1RidgeNameRoomNumber: '',
            witness1Name: '',
            witness2RidgeNameRoomNumber: '',
            witness2Name: '',
            otherWitness: '',
            clearErrorBrowseStartTime: false,
            clearErrorBrowseEndTime: false,
            isErrorOfPeriod: false,
        }

        this.handleChangeBrowseDate = this.handleChangeBrowseDate.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeTime = this.handleChangeTime.bind(this)
    }

    componentDidUpdate(prevProps: Props, prevState: State): void {
        if (prevProps.isInitial !== this.props.isInitial) {
            this.setState({
                browseDate: '',
                browseStartTimeHours: '',
                browseStartTimeMinutes: '',
                browseEndTimeHours: '',
                browseEndTimeMinutes: '',
                witness1RidgeNameRoomNumber: '',
                witness1Name: '',
                witness2RidgeNameRoomNumber: '',
                witness2Name: '',
                otherWitness: '',
                clearErrorBrowseStartTime: false,
                clearErrorBrowseEndTime: false,
                isErrorOfPeriod: false,
            })
        }
        if (!prevState.clearErrorBrowseStartTime &&
            prevState.browseStartTimeHours !== this.state.browseStartTimeHours ||
            prevState.browseStartTimeMinutes !== this.state.browseStartTimeMinutes) {
            this.setState({clearErrorBrowseStartTime: true})
        }
        if (!prevState.clearErrorBrowseEndTime &&
            prevState.browseEndTimeHours !== this.state.browseEndTimeHours ||
            prevState.browseEndTimeMinutes !== this.state.browseEndTimeMinutes) {
            this.setState({clearErrorBrowseEndTime: true})
        }
    }

    getSelectableHours(value: string): OptionProps[] {
        const data: OptionProps[] = HOURS.values().map(item => {
            return {
                label: item.label,
                value: item.value,
            }
        })
        const emptyLabel: string = isMobile ? '時' : '--'

        return value ? data : addEmptyData(data, emptyLabel)
    }

    getSelectableMinutes(value: string): OptionProps[] {
        const data: OptionProps[] = RESERVATION_TIME_UNIT_MINUTES.values().map(item => {
            return {
                label: item.label,
                value: item.value,
            }
        })
        const emptyLabel: string = isMobile ? '分' : '--'

        return value ? data : addEmptyData(data, emptyLabel)
    }

    getFormattedTime(hours: string, minutes: string): string {
        if (hours && minutes) {
            const padMinutes = ('0' + minutes).slice(-2)
            return `${hours}:${padMinutes}`
        }
        return ''
    }

    handleChangeBrowseDate(date: Nullable<Date>): void {
        const browseDate = date ? formatForDateInput(date.toString()) : ''
        this.setState({browseDate: browseDate}, () => {
            this.updateBrowseWitnessInfo()
        })
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateBrowseWitnessInfo()
        })
    }

    handleChangeTime(event: SelectChangeEvent<unknown>): void {
        const key = event.target.name as keyof State

        this.setState({...this.state, [key]: event.target.value}, () => {
            this.updateErrorOfPeriod()
        })
    }

    updateBrowseWitnessInfo(): void {
        const {
            browseStartTimeHours,
            browseStartTimeMinutes,
            browseEndTimeHours,
            browseEndTimeMinutes,
        } = this.state

        this.props.onChange({
            ...this.state,
            browseStartTime: this.getFormattedTime(browseStartTimeHours, browseStartTimeMinutes),
            browseEndTime: this.getFormattedTime(browseEndTimeHours, browseEndTimeMinutes),
        })
    }

    updateErrorOfPeriod(): void {
        const {
            browseStartTimeHours,
            browseStartTimeMinutes,
            browseEndTimeHours,
            browseEndTimeMinutes,
        } = this.state

        let isErrorOfPeriod: boolean
        if (!browseStartTimeHours || !browseStartTimeMinutes || !browseEndTimeHours || !browseEndTimeMinutes) {
            isErrorOfPeriod = false
        } else {
            const startTime = fromTimeToMoment(browseStartTimeHours, browseStartTimeMinutes)
            const endTime = fromTimeToMoment(browseEndTimeHours, browseEndTimeMinutes)
            isErrorOfPeriod = !startTime.isBefore(endTime)
        }

        this.setState({isErrorOfPeriod: isErrorOfPeriod}, () => {
            this.updateBrowseWitnessInfo()
        })
    }

    renderFormItemPc(
        title: string,
        component: ReactNode,
        required: boolean = false,
    ): ReactNode {
        return <Grid container alignItems={'center'}>
            <Grid item xs={3}>
                <RowFlexContainer>
                    <FormTitle>{title}</FormTitle>
                    {required && <Box ml={'8px'} flexGrow={1}><RequiredChip label={'必須'}/></Box>}
                </RowFlexContainer>
            </Grid>
            <Grid item xs={9}>
                <Box>{component}</Box>
            </Grid>
        </Grid>
    }

    renderBrowseFormPc(): ReactNode {
        const {
            browseDate, browseStartTimeHours, browseStartTimeMinutes,
            browseEndTimeHours, browseEndTimeMinutes,
        } = this.state

        return <>
            <Box mb={'16px'}>
                {this.renderFormItemPc('日付',
                    <Box width={'200px'}>
                        <PPDatePicker
                            value={browseDate ? new Date(browseDate) : null}
                            onChangeDate={this.handleChangeBrowseDate}
                            eventKeys={['browseDate']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </Box>,
                    true,
                )}
            </Box>
            <Box mb={'16px'}>
                {this.renderFormItemPc('開始時間',
                    <>
                        <FullWidthLeftRowFlexContainer>
                            <PPSelect
                                inputProps={{
                                    name: 'browseStartTimeHours',
                                    value: browseStartTimeHours,
                                }}
                                data={this.getSelectableHours(browseStartTimeHours)}
                                value={browseStartTimeHours}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeTime}
                            />
                            <div>：</div>
                            <PPSelect
                                inputProps={{
                                    name: 'browseStartTimeMinutes',
                                    value: browseStartTimeMinutes,
                                }}
                                data={this.getSelectableMinutes(browseStartTimeMinutes)}
                                value={browseStartTimeMinutes}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeTime}
                            />
                        </FullWidthLeftRowFlexContainer>
                        <PPErrorDisplaySpan
                            eventEmitter={this.props.eventEmitter}
                            eventKeys={['browseStartTime']}
                            clearError={this.state.clearErrorBrowseStartTime}
                        />
                    </>,
                    true,
                )}
            </Box>
            <Box mb={'16px'}>
                {this.renderFormItemPc('終了時間',
                    <>
                        <FullWidthLeftRowFlexContainer>
                            <PPSelect
                                inputProps={{
                                    name: 'browseEndTimeHours',
                                    value: browseEndTimeHours,
                                }}
                                data={this.getSelectableHours(browseEndTimeHours)}
                                value={browseEndTimeHours}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeTime}
                            />
                            <div>：</div>
                            <PPSelect
                                inputProps={{
                                    name: 'browseEndTimeMinutes',
                                    value: browseEndTimeMinutes,
                                }}
                                data={this.getSelectableMinutes(browseEndTimeMinutes)}
                                value={browseEndTimeMinutes}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeTime}
                            />
                        </FullWidthLeftRowFlexContainer>
                        <FormErrorMessage messages={
                            this.state.isErrorOfPeriod ? [{message: '開始時間が終了時間以降の時間になっています。'}] : undefined
                        }/>
                        <PPErrorDisplaySpan
                            eventEmitter={this.props.eventEmitter}
                            eventKeys={['browseEndTime']}
                            clearError={this.state.clearErrorBrowseEndTime}
                        />
                    </>,
                    true,
                )}
            </Box>
        </>
    }

    renderWitnessFormPc(): ReactNode {
        const {
            witness1RidgeNameRoomNumber, witness1Name,
            witness2RidgeNameRoomNumber, witness2Name, otherWitness,
        } = this.state

        return <>
            <Box mb={'16px'}>
                {this.renderFormItemPc('立会いする理事等',
                    <FullWidthLeftRowFlexContainer>
                        <Box width={'120px'}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        name: 'witness1RidgeNameRoomNumber',
                                        maxLength: 25,
                                        placeholder: 'A棟101',
                                    },
                                }}
                                fullWidth
                                value={witness1RidgeNameRoomNumber}
                                eventKeys={['witness1RidgeNameRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeText}
                            />
                        </Box>
                        <Box ml={'8px'} mr={'16px'}>号室</Box>
                        <Box flex={1}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        name: 'witness1Name',
                                        maxLength: 20,
                                        placeholder: '素敵 太郎',
                                    },
                                }}
                                fullWidth
                                value={witness1Name}
                                eventKeys={['witness1Name']}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeText}
                            />
                        </Box>
                    </FullWidthLeftRowFlexContainer>,
                )}
            </Box>
            <Box mb={'16px'}>
                {this.renderFormItemPc('',
                    <FullWidthLeftRowFlexContainer>
                        <Box width={'120px'}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        name: 'witness2RidgeNameRoomNumber',
                                        maxLength: 25,
                                        placeholder: 'A棟101',
                                    },
                                }}
                                fullWidth
                                value={witness2RidgeNameRoomNumber}
                                eventKeys={['witness2RidgeNameRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeText}
                            />
                        </Box>
                        <Box ml={'8px'} mr={'16px'}>号室</Box>
                        <Box flex={1}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        name: 'witness2Name',
                                        maxLength: 20,
                                        placeholder: '素敵 太郎',
                                    },
                                }}
                                fullWidth
                                value={witness2Name}
                                eventKeys={['witness2Name']}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.handleChangeText}
                            />
                        </Box>
                    </FullWidthLeftRowFlexContainer>,
                )}
            </Box>
            <Box mb={'16px'}>
                {this.renderFormItemPc('',
                    <PPTextField
                        InputProps={{
                            inputProps: {
                                name: 'otherWitness',
                                maxLength: 30,
                                placeholder: 'その他立会い者',
                            },
                        }}
                        fullWidth
                        value={otherWitness}
                        eventKeys={['otherWitness']}
                        eventEmitter={this.props.eventEmitter}
                        onChange={this.handleChangeText}
                    />,
                )}
            </Box>
        </>
    }

    renderFormItemSp(
        title: string,
        component: ReactNode,
        required: boolean = false,
    ): ReactNode {
        return <FullWidthLeftColumnFlexContainer>
            <RowFlexContainer>
                <FormTitle>{title}</FormTitle>
                {required && <Box ml={'8px'} flexGrow={1}><RequiredChip label={'必須'}/></Box>}
            </RowFlexContainer>
            <Box mt={'5px'} width={'100%'}>{component}</Box>
        </FullWidthLeftColumnFlexContainer>
    }

    renderBrowseFormSp(): ReactNode {
        const {
            browseDate, browseStartTimeHours, browseStartTimeMinutes,
            browseEndTimeHours, browseEndTimeMinutes,
        } = this.state

        return <>
            <Box mb={'16px'}>
                {this.renderFormItemSp('日付',
                    <Box flex={1}>
                        <OutlinedDatePicker
                            value={new Date(browseDate)}
                            onChangeDate={this.handleChangeBrowseDate}
                            eventKeys={['browseDate']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </Box>,
                    true,
                )}
            </Box>
            <Box mb={'16px'}>
                {this.renderFormItemSp('開始時間',
                    <>
                        <FullWidthLeftRowFlexContainer>
                            <Box flex={1}>
                                <PPSelect
                                    inputProps={{
                                        name: 'browseStartTimeHours',
                                        value: browseStartTimeHours,
                                    }}
                                    data={this.getSelectableHours(browseStartTimeHours)}
                                    value={browseStartTimeHours}
                                    variant={'outlined'}
                                    fullWidth
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeTime}
                                />
                            </Box>
                            <div>：</div>
                            <Box flex={1}>
                                <PPSelect
                                    inputProps={{
                                        name: 'browseStartTimeMinutes',
                                        value: browseStartTimeMinutes,
                                    }}
                                    data={this.getSelectableMinutes(browseStartTimeMinutes)}
                                    value={browseStartTimeMinutes}
                                    variant={'outlined'}
                                    fullWidth
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeTime}
                                />
                            </Box>
                        </FullWidthLeftRowFlexContainer>
                        <PPErrorDisplaySpan
                            eventEmitter={this.props.eventEmitter}
                            eventKeys={['browseStartTime']}
                            clearError={this.state.clearErrorBrowseStartTime}
                        />
                    </>,
                    true,
                )}
            </Box>
            <Box mb={'16px'}>
                {this.renderFormItemSp('終了時間',
                    <>
                        <FullWidthLeftRowFlexContainer>
                            <Box flex={1}>
                                <PPSelect
                                    inputProps={{
                                        name: 'browseEndTimeHours',
                                        value: browseEndTimeHours,
                                    }}
                                    data={this.getSelectableHours(browseEndTimeHours)}
                                    value={browseEndTimeHours}
                                    variant={'outlined'}
                                    fullWidth
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeTime}
                                />
                            </Box>
                            <div>：</div>
                            <Box flex={1}>
                                <PPSelect
                                    inputProps={{
                                        name: 'browseEndTimeMinutes',
                                        value: browseEndTimeMinutes,
                                    }}
                                    data={this.getSelectableMinutes(browseEndTimeMinutes)}
                                    value={browseEndTimeMinutes}
                                    variant={'outlined'}
                                    fullWidth
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeTime}
                                />
                            </Box>
                        </FullWidthLeftRowFlexContainer>
                        <FormErrorMessage messages={
                            this.state.isErrorOfPeriod ? [{message: '開始時間が終了時間以降の時間になっています。'}] : undefined
                        }/>
                        <PPErrorDisplaySpan
                            eventEmitter={this.props.eventEmitter}
                            eventKeys={['browseEndTime']}
                            clearError={this.state.clearErrorBrowseEndTime}
                        />
                    </>,
                    true,
                )}
            </Box>
        </>
    }

    renderWitnessFormSp(): ReactNode {
        const {
            witness1RidgeNameRoomNumber, witness1Name,
            witness2RidgeNameRoomNumber, witness2Name, otherWitness,
        } = this.state

        return <Box mb={'16px'}>
            {this.renderFormItemSp('立会いする理事等',
                <>
                    <Box mb={'8px'} width={'100%'}>
                        <FullWidthLeftRowFlexContainer>
                            <Box width={'90px'}>
                                <PPOutlinedTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'witness1RidgeNameRoomNumber',
                                            maxLength: 25,
                                            placeholder: 'A棟101',
                                        },
                                    }}
                                    variant={'outlined'}
                                    fullWidth
                                    value={witness1RidgeNameRoomNumber}
                                    eventKeys={['witness1RidgeNameRoomNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeText}
                                />
                            </Box>
                            <Box ml={'8px'} mr={'16px'} width={'32px'}>号室</Box>
                            <Box flex={1}>
                                <PPOutlinedTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'witness1Name',
                                            maxLength: 20,
                                            placeholder: '素敵 太郎',
                                        },
                                    }}
                                    variant={'outlined'}
                                    fullWidth
                                    value={witness1Name}
                                    eventKeys={['witness1Name']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeText}
                                />
                            </Box>
                        </FullWidthLeftRowFlexContainer>
                    </Box>
                    <Box mb={'8px'} width={'100%'}>
                        <FullWidthLeftRowFlexContainer>
                            <Box width={'90px'}>
                                <PPOutlinedTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'witness2RidgeNameRoomNumber',
                                            maxLength: 25,
                                            placeholder: 'A棟101',
                                        },
                                    }}
                                    variant={'outlined'}
                                    fullWidth
                                    value={witness2RidgeNameRoomNumber}
                                    eventKeys={['witness2RidgeNameRoomNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeText}
                                />
                            </Box>
                            <Box ml={'8px'} mr={'16px'} width={'32px'}>号室</Box>
                            <Box flex={1}>
                                <PPOutlinedTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'witness2Name',
                                            maxLength: 20,
                                            placeholder: '素敵 太郎',
                                        },
                                    }}
                                    variant={'outlined'}
                                    fullWidth
                                    value={witness2Name}
                                    eventKeys={['witness2Name']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleChangeText}
                                />
                            </Box>
                        </FullWidthLeftRowFlexContainer>
                    </Box>
                    <Box mb={'16px'} width={'100%'}>
                        <PPOutlinedTextField
                            InputProps={{
                                inputProps: {
                                    name: 'otherWitness',
                                    maxLength: 30,
                                    placeholder: 'その他立会い者',
                                },
                            }}
                            variant={'outlined'}
                            fullWidth
                            value={otherWitness}
                            eventKeys={['otherWitness']}
                            eventEmitter={this.props.eventEmitter}
                            onChange={this.handleChangeText}
                        />
                    </Box>
                </>,
            )}
        </Box>
    }

    render(): ReactNode {
        return (
            <Box mt={'16px'} mb={'8px'}>
                <Box mt={'16px'} mb={'8px'}>
                    <DialogItemNameArea>閲覧日時・立会い理事</DialogItemNameArea>
                </Box>
                {isMobile ?
                    <>
                        {this.renderBrowseFormSp()}
                        <Box mt={'16px'} mb={'8px'}>
                            {this.renderWitnessFormSp()}
                        </Box>
                    </>
                    :
                    <>
                        {this.renderBrowseFormPc()}
                        <Box mt={'16px'} mb={'8px'}>
                            {this.renderWitnessFormPc()}
                        </Box>
                    </>
                }
            </Box>
        )
    }
}

const FormTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: ${Colors.AccentDark};
`
